import React from 'react'
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

const Timer = ({ label, initialMinute, initialSeconds, callAction, timeOutLabel }) => {
    const [ minutes, setMinutes ] = useState(initialMinute)
    const [seconds, setSeconds ] =  useState(initialSeconds)
    useEffect(()=>{
    let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1)
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    callAction()
                    clearInterval(myInterval)
                } else {
                    setMinutes(minutes - 1)
                    setSeconds(59)
                }
            } 
        }, 1000)
        return ()=> {
            clearInterval(myInterval)
          }
    })

    return (
        <div>
        { minutes === 0 && seconds === 0
            ? timeOutLabel
        : <p>{label+' '} {minutes}:{seconds < 10 ?  `0${seconds}` : seconds}{' minutes'}</p> 
        }
        </div>
    )
}
Timer.propTypes = {
    label: PropTypes.object,
    initialMinute: PropTypes.string,
    initialSeconds: PropTypes.string,
    callAction: PropTypes.func,
    timeOutLabel: PropTypes.object,

}

Timer.defaultProps = {
    label: '',
    initialMinute: 0,
    initialSeconds: 0,
    callAction: () => {},
    timeOutLabel:''
}
export default Timer